import { Layer, Logger } from 'effect';
import { makeAnnouncementAtoms } from '@vs-shop/engine/atom/announcements/announcementAtoms';
import { Announcements } from '@vs-shop/engine/service/announcements/Announcements';
import { CookiesStoreBrowser } from '@vs-shop/engine/service/cookies/CookiesStoreBrowser';
import { AlertMessagesDismissedLive } from '../../service/alertMessagesDismissed/AlertMessagesDismissed';
import { sentryLogger } from '../../service/logger/SentryLogger';

export const announcementAtoms = makeAnnouncementAtoms(
  Announcements.layer.pipe(
    Layer.provide(AlertMessagesDismissedLive.pipe(Layer.provide(CookiesStoreBrowser))),
    Layer.provide(Logger.layer([sentryLogger], { mergeWithExisting: true }))
  )
);
